<template>
  <div id="transhipment-negotiations-by-id">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" :loading="loading">
      <div class="d-flex justify-space-between px-5 pt-5 align-center">
        <h1>Negociação | {{ transhipmentName }}</h1>
      </div>

      <v-row class="px-5 py-5">
        <v-col cols="3">
          <h6>Hierarquia</h6>
          <div v-if="isLoading">
            <v-progress-circular indeterminate color="primary" size="22" class="mt-4 ml-4" />
          </div>
          <div v-else class="pt-2">
            <v-radio-group readonly v-model="selectedType" row hide-details>
              <v-radio
                v-for="{ id, name } in negotiationTypes"
                :key="id"
                :label="name"
                :value="id"
                @click="handleEditConfirm(id)"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-col>

        <v-divider vertical class="mr-4 pt-0"></v-divider>

        <v-col cols="4">
          <h6>Tipo de negociação</h6>
          <div v-if="isLoading">
            <v-progress-circular indeterminate color="primary" size="22" class="mt-4 ml-4" />
          </div>
          <div v-else class="pt-2">
            <v-radio-group readonly v-model="selectedSubType" row hide-details>
              <v-radio
                v-for="{ id, name } in negotiationSubTypes"
                :key="id"
                :label="name"
                :value="id"
                @click="handleEditConfirmSubType(id)"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mx-5" />

      <div class="px-5 py-5 d-flex align-center justify-space-between">
        <h6>Tarifas</h6>
        <v-btn @click="openCreateNegociationDialog" elevation="2" color="success" large>NOVA TARIFA</v-btn>
      </div>

      <div class="table px-5">
        <v-tabs v-model="tab">
          <v-tabs-slider></v-tabs-slider>

          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pb-4">
          <v-tab-item>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">NOME</th>
                    <th class="text-left" v-if="!isPercentage">VALOR</th>
                    <th class="text-left" v-if="isPercentage">PORCENTAGEM</th>
                    <th class="text-left" v-if="isPercentage">VALOR MÍNIMO</th>
                    <th class="text-right">AÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(negociation, negociationIndex) in negotiationsCity">
                    <tr :key="negociationIndex">
                      <td>
                        <span v-if="negociation.children.length" class="mr-1">
                          <v-icon @click="onClickExpand(negociation)">
                            mdi-{{ expandedKeys[negociation.key] ? 'chevron-down' : 'chevron-right' }}
                          </v-icon>
                        </span>
                        {{ negociation.data.name }}
                      </td>
                      <td v-if="!isPercentage">
                        {{ transformPrice(negociation.data.price) }}
                      </td>
                      <td v-if="isPercentage">
                        {{ transformPercentage(negociation.data.percentage) }}
                      </td>
                      <td v-if="isPercentage">
                        {{ transformPrice(negociation.data.minimumValue) }}
                      </td>
                      <td class="text-right">
                        <div>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <PencilSVG @click="openEditNegociationDialog(negociation)" v-bind="attrs" v-on="on" />
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <MoreSVG
                                class="ml-3"
                                @click="openCreateNegociationWeightDialog(negociation.data)"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span>Nova Tarifa por Peso</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <TrashSVG
                                class="ml-3"
                                role="button"
                                @click="openDialogTrashCity(negociation)"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span>Deletar</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                    <template v-if="expandedKeys[negociation.key]">
                      <tr
                        v-for="(negociationWeight, negociationWeightIndex) in negociation.children"
                        :key="`${negociationIndex}-${negociationWeightIndex}`"
                      >
                        <td class="pl-9">
                          <v-icon> mdi-circle-medium </v-icon>
                          {{ negociationWeight.data.name }}
                        </td>
                        <td v-if="!isPercentage">
                          {{ transformPrice(negociationWeight.data.price) }}
                        </td>
                        <td v-if="isPercentage">
                          {{ transformPercentage(negociationWeight.data.percentage) }}
                        </td>
                        <td v-if="isPercentage">
                          {{ transformPrice(negociationWeight.data.minimumValue) }}
                        </td>

                        <td class="text-right pr-12">
                          <div>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <PencilSVG
                                  @click="
                                    openEditNegociationWeightDialog(negociation.data, false, negociationWeight.data.id)
                                  "
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <span>Editar</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <TrashSVG
                                  class="ml-3"
                                  role="button"
                                  @click="openDialogTrashCity(negociationWeight)"
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <span>Deletar</span>
                            </v-tooltip>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
            <div v-if="negotiationsCity.length === 0" class="d-flex justify-center pt-4" style="color: #909090">
              Nenhuma tarifa cadastrada
            </div>
            <div v-else class="pt-16 mt-2">
              <v-pagination v-model="page" :length="paginateCity.totalPages" :total-visible="7"></v-pagination>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">NOME</th>
                    <th class="text-left" v-if="!isPercentage">VALOR</th>
                    <th class="text-left" v-if="isPercentage">PORCENTAGEM</th>
                    <th class="text-left" v-if="isPercentage">VALOR MÍNIMO</th>
                    <th class="text-right">AÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(negociation, negociationIndex) in negotiationsCNPJ">
                    <tr :key="negociationIndex">
                      <td>
                        <span v-if="negociation.children.length" class="mr-1">
                          <v-icon @click="onClickCnpjExpand(negociation)">
                            mdi-{{ expandedCNPJKeys[negociation.key] ? 'chevron-down' : 'chevron-right' }}
                          </v-icon>
                        </span>
                        {{ transformCNPJ(negociation.data.cpfOrCnpj) }}
                      </td>
                      <td v-if="!isPercentage">
                        {{ transformPrice(negociation.data.price) }}
                      </td>
                      <td v-if="isPercentage">
                        {{ transformPercentage(negociation.data.percentage) }}
                      </td>
                      <td v-if="isPercentage">
                        {{ transformPrice(negociation.data.minimumValue) }}
                      </td>
                      <td class="text-right">
                        <div>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <PencilSVG
                                @click="openEditNegociationDialog(negociation, true)"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <MoreSVG
                                class="ml-3"
                                @click="openCreateNegociationWeightDialog(negociation.data, true)"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span>Nova Tarifa por Peso</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <TrashSVG
                                class="ml-3"
                                role="button"
                                @click="openDialogTrashCNPJ(negociation)"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span>Deletar</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                    <template v-if="expandedCNPJKeys[negociation.key]">
                      <tr
                        v-for="(negociationWeight, negociationWeightIndex) in negociation.children"
                        :key="`${negociationIndex}-${negociationWeightIndex}`"
                      >
                        <td class="pl-9">
                          <v-icon> mdi-circle-medium </v-icon>
                          {{ negociationWeight.data.cpfOrCnpj }}
                        </td>
                        <td v-if="!isPercentage">
                          {{ transformPrice(negociationWeight.data.price) }}
                        </td>
                        <td v-if="isPercentage">
                          {{ transformPercentage(negociationWeight.data.percentage) }}
                        </td>
                        <td v-if="isPercentage">
                          {{ transformPrice(negociationWeight.data.minimumValue) }}
                        </td>

                        <td class="text-right pr-12">
                          <div>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <PencilSVG
                                  @click="
                                    openEditNegociationWeightDialog(negociation.data, true, negociationWeight.data.id)
                                  "
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <span>Editar</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <TrashSVG
                                  class="ml-3"
                                  role="button"
                                  @click="openDialogTrashCNPJ(negociationWeight)"
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <span>Deletar</span>
                            </v-tooltip>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
            <div v-if="negotiationsCNPJ.length === 0" class="d-flex justify-center pt-4" style="color: #909090">
              Nenhuma tarifa cadastrada
            </div>
            <div v-else class="pt-16 mt-2">
              <v-pagination v-model="cpnjPage" :length="paginateCNPJ.totalPages" :total-visible="7"></v-pagination>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>

    <transhipment-tariff-form-dialog
      :isOpen.sync="negociationFormDialogOpen"
      :typeNegotiation="subTypeNegotiationName"
      @shouldRefresh="fetchAllNegotiations"
      :negociationIdToEdit="negociationToEdit"
    />

    <transhipment-weight-tariff-form-dialog
      :isOpen.sync="negociationFormWeightDialogOpen"
      @shouldRefresh="fetchAllNegotiations"
      :negociation="negociationToWeightCreation"
      :negociationWeightIdToEdit="negociationWeightIdToEdit"
    />

    <v-dialog v-model="dialogTrashCity" persistent max-width="460">
      <v-card class="align-center text-center">
        <v-card-title class="headline justify-center"> Deletar tarifa </v-card-title>
        <v-card-text>
          Você confirma estar deletando a tarifa para o município
          {{ trashItemCity.name }}?
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" @click="dialogTrashCity = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" @click="deleteItemCity()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTrashCNPJ" persistent max-width="460">
      <v-card class="align-center text-center">
        <v-card-title class="headline justify-center"> Deletar tarifa </v-card-title>
        <v-card-text>
          Você confirma estar deletando a tarifa para o CNPJ
          {{ trashItemCNPJ.cpfOrCnpj }}?
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" @click="dialogTrashCNPJ = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" @click="deleteItemCNPJ()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <edit-confirm-dialog
      :isOpen.sync="isConfirmEditDialogOpen"
      @confirmClick="handleEditNegotiation"
      :isConfirmBtnLoading="isEditButtonLoading"
      title="Editar negociação"
      body-text="Você confirma estar editando esta negociação?"
    />
    <MessagesError :errors="errors" @closeMessages="errors = []" :type="errorsType" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import TranshipmentTariffFormDialog from '@/components/Transhipment/TranshipmentTariffFormDialog.vue';
import TranshipmentWeightTariffFormDialog from '@/components/Transhipment/TranshipmentWeightTariffFormDialog.vue';
import MessagesError from '@/components/MessagesError.vue';
import { orderBy } from 'lodash';
import EditConfirmDialog from '@/components/ConfirmDialog';

import BreadCrumb from '../../../components/BreadCrumb.vue';
import maskCNPJ from '../../../utils/maskCNPJ';
import maskPrice from '../../../utils/maskPrice';
import maskPercentage from '../../../utils/maskPercentage';
import maskWeight from '../../../utils/maskWeight';

// SVGs
import TrashSVG from '../../../assets/img/trash.svg';
import MoreSVG from '../../../assets/img/more.svg';
import PencilSVG from '../../../assets/img/pencil.svg';

export default {
  name: 'TranshipmentNegotiationsByID',
  components: {
    BreadCrumb,
    TranshipmentTariffFormDialog,
    TranshipmentWeightTariffFormDialog,
    TrashSVG,
    MoreSVG,
    PencilSVG,
    MessagesError,
    EditConfirmDialog
  },
  data: () => ({
    negotiationTypeToEdit: null,
    negotiationSubTypeToEdit: null,
    isConfirmEditDialogOpen: false,
    isEditButtonLoading: false,
    isLoading: false,
    negotiation: null,
    subTypeNegotiationName: null,
    selectedType: null,
    selectedSubType: null,
    negotiationTypes: [],
    negotiationSubTypes: [],
    negociationFormWeightDialogOpen: false,
    negociationToWeightCreation: null,
    negociationToEdit: null,
    negociationWeightIdToEdit: null,
    errors: [],
    errorsType: 'success',
    negociationFormDialogOpen: false,
    dialogTrashCity: false,
    trashItemCity: {},
    dialogTrashCNPJ: false,
    trashItemCNPJ: {},
    tab: 0,
    items: ['MUNICÍPIO', 'CNPJ'],
    loading: true,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '#'
      },
      {
        text: 'Transbordos',
        disabled: false,
        to: '/transhipments/',
        exact: true
      },
      {
        text: 'Negociações',
        disabled: false,
        to: '/transhipments/negotiations',
        exact: true
      },
      {
        text: 'Visualizar tarifas',
        disabled: true
      }
    ],
    columnsCity: [
      { field: 'name', header: 'NOME', expander: true },
      { field: 'price', header: 'VALOR', expander: false },
      { field: 'percentage', header: 'PORCENTAGEM', expander: false },
      { field: 'minimumValue', header: 'VALOR MÍNIMO', expander: false },
      { field: 'actions', header: 'AÇÕES', expander: false }
    ],
    columns: [
      { field: 'cpfOrCnpj', header: 'CNPJ/CPF', expander: true },
      { field: 'price', header: 'VALOR', expander: false },
      { field: 'percentage', header: 'PORCENTAGEM', expander: false },
      { field: 'minimumValue', header: 'VALOR MÍNIMO', expander: false },
      { field: 'actions', header: 'AÇÕES', expander: false }
    ],
    expandedKeys: {},
    expandedCNPJKeys: {}
  }),
  computed: {
    ...mapState('TranshipmentStore', ['paginateCity', 'paginateCNPJ', 'transhipmentSelectedName']),
    ...mapGetters('TranshipmentStore', ['getNegotiationsCity', 'getNegotiationsCNPJ']),
    negotiationsCity() {
      const newsCity = this.getNegotiationsCity.map((item, index) => {
        const children = item.negotiationsCityWeightDelivery.map((item, indexChildren) => {
          return {
            data: {
              ...item,
              name: 'Peso: ' + this.transformWeight(item.upToWeight),
              isChildren: true
            },
            key: `${index}-${indexChildren}`
          };
        });

        const returnItem = {
          data: item,
          key: `${index}`,
          children: children
        };
        return returnItem;
      });
      return newsCity;
    },
    negotiationsCNPJ() {
      const newsCNPJ = this.getNegotiationsCNPJ.map((item, index) => {
        const children = item.negotiationsCpfOrCnpjWeightDelivery.map((item, indexChildren) => {
          return {
            data: {
              ...item,
              cpfOrCnpj: 'Peso: ' + this.transformWeight(item.upToWeight),
              isChildren: true
            },
            key: `${index}-${indexChildren}`
          };
        });

        const returnItem = {
          data: item,
          key: `${index}`,
          children: children
        };
        return returnItem;
      });

      return newsCNPJ;
    },
    cpnjPage: {
      get() {
        return this.paginateCNPJ.pageNumber;
      },
      set(value) {
        this.setPageNumberCNPJ(value);

        this.fetchAllNegotiations();
      }
    },
    page: {
      get() {
        return this.paginateCity.pageNumber;
      },
      set(value) {
        this.setPageNumberCity(value);

        this.fetchAllNegotiations();
      }
    },
    id() {
      return this.$route.params.id;
    },
    transhipmentName() {
      return this.negotiation ? this.negotiation.name : '';
    },
    isPercentage() {
      return this.subTypeNegotiationName == 'Percentual';
    }
  },
  async created() {
    await this.fetchNegotiationTypes();
    await this.fetchNegotiationSubTypes();
    await this.fetchNegotiation();
    this.setPageNumberCity(1);
    this.setPageNumberCNPJ(1);
    await this.fetchAllNegotiations();
  },
  mounted() {},
  methods: {
    ...mapMutations('TranshipmentStore', ['setTranshipmentSelectedName', 'setPageNumberCity', 'setPageNumberCNPJ']),
    ...mapActions('TranshipmentStore', [
      'fetchTranshipment',
      'fetchTranshipmentNegotiationCNPJByID',
      'fetchTranshipmentNegotiationCityByID',
      'deleteNegotiationCity',
      'deleteNegotiationCityWeight',
      'deleteNegotiationCNPJ',
      'getNegotiationTypes',
      'getNegotiationSubTypes',
      'getNegotiation',
      'editNegotiation'
    ]),

    async fetchNegotiation() {
      try {
        this.isLoading = true;
        this.negotiation = await this.getNegotiation(this.id);

        const types = {};
        const subTypes = {};
        this.negotiationTypes.forEach((type) => {
          types[type.name] = type.id;
        });
        this.negotiationSubTypes.forEach((type) => {
          subTypes[type.name] = type.id;
        });

        this.selectedType = types[this.negotiation.typeNegotiation];
        this.selectedSubType = subTypes[this.negotiation.subTypeNegotiation];
        this.subTypeNegotiationName = this.negotiation.subTypeNegotiation;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async handleEditNegotiation() {
      this.isEditButtonLoading = true;

      let params = {
        id: this.negotiation.id,
        typeNegotiationId: this.negotiationTypeToEdit,
        subTypeNegotiationId: this.negotiationSubTypeToEdit
      };

      try {
        const status = await this.editNegotiation(params);
        if (status.success) {
          this.selectedType = this.negotiationTypeToEdit;
          this.errorsType = 'success';
          this.errors = ['Negociação editada com sucesso!'];
          this.isConfirmEditDialogOpen = false;
          this.fetchAllNegotiations();
          await this.fetchNegotiation();
        } else {
          this.errorsType = 'error';
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isEditButtonLoading = false;
      }
    },

    handleEditConfirm(negociationType) {
      if (negociationType === this.selectedType) {
        return;
      } else {
        this.negotiationTypeToEdit = negociationType;
        this.negotiationSubTypeToEdit = this.selectedSubType;
        this.isConfirmEditDialogOpen = true;
      }
    },
    handleEditConfirmSubType(negociationSubType) {
      if (negociationSubType === this.selectedSubType) {
        return;
      } else {
        this.negotiationTypeToEdit = this.selectedType;
        this.negotiationSubTypeToEdit = negociationSubType;
        this.isConfirmEditDialogOpen = true;
      }
    },

    transformPrice(price) {
      return maskPrice(price);
    },
    transformPercentage(price) {
      return maskPercentage(price);
    },
    transformWeight(weight) {
      return maskWeight(weight);
    },
    transformCNPJ(str) {
      if (str.length === 14 || str.length === 11) {
        return maskCNPJ(str);
      }

      return str;
    },
    onClickExpand({ key }) {
      if (this.expandedKeys[key]) {
        this.$set(this.expandedKeys, key, false);
      } else {
        this.$set(this.expandedKeys, key, true);
      }
    },
    onClickCnpjExpand({ key }) {
      if (this.expandedCNPJKeys[key]) {
        this.$set(this.expandedCNPJKeys, key, false);
      } else {
        this.$set(this.expandedCNPJKeys, key, true);
      }
    },
    async fetchAllNegotiations() {
      this.loading = true;
      try {
        const { transhipmentId } = this.negotiation;
        await this.fetchTranshipmentNegotiationCNPJByID(transhipmentId);
        await this.fetchTranshipmentNegotiationCityByID(transhipmentId);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchNegotiationTypes() {
      try {
        const types = await this.getNegotiationTypes();
        this.negotiationTypes = orderBy(types, ['name'], ['desc']);
        const [stopType] = this.negotiationTypes;
        this.selectedType = stopType.id;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchNegotiationSubTypes() {
      try {
        const subTypes = await this.getNegotiationSubTypes();
        this.negotiationSubTypes = orderBy(subTypes, ['name'], ['desc']);
        const [stopType] = this.negotiationSubTypes;
        this.selectedSubType = stopType.id;
      } catch (error) {
        console.error(error);
      }
    },

    async deleteItemCity() {
      this.loading = true;

      const { isChildren } = this.trashItemCity.data;

      try {
        if (isChildren) {
          const status = await this.deleteNegotiationCityWeight({
            negotiationCityId: this.trashItemCity.data.id,
            id: this.trashItemCity.data.id
          });
          this.handleSuccessDelete(status.success);
        } else {
          const status = await this.deleteNegotiationCity(this.trashItemCity.data.id);
          this.handleSuccessDelete(status.success);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.dialogTrashCity = false;
        this.loading = false;
      }
    },
    openDialogTrashCity(item, index) {
      this.dialogTrashCity = true;
      this.trashItemCity = {
        ...item,
        index
      };
    },
    async deleteItemCNPJ() {
      this.loading = true;

      const { isChildren } = this.trashItemCNPJ.data;

      try {
        if (isChildren) {
          const status = await this.deleteNegotiationCityWeight({
            negotiationCpfOrCnpjId: this.trashItemCNPJ.data.id,
            id: this.trashItemCNPJ.data.id
          });
          this.handleSuccessDelete(status.success);
        } else {
          const status = await this.deleteNegotiationCNPJ(this.trashItemCNPJ.data.id);
          this.handleSuccessDelete(status.success);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.dialogTrashCNPJ = false;
        this.loading = false;
      }
    },

    openCreateNegociationDialog() {
      this.negociationFormDialogOpen = true;
      this.negociationToEdit = null;
    },

    openEditNegociationDialog(negociation, isCnpj = false) {
      this.negociationToEdit = { ...negociation, isCnpj };
      this.negociationFormDialogOpen = true;
    },

    openCreateNegociationWeightDialog({ id, name, cpfOrCnpj }, isCpnj = false) {
      this.negociationFormWeightDialogOpen = true;
      const isPercentage = this.isPercentage;
      this.negociationToWeightCreation = { id, name, cpfOrCnpj, isCpnj, isPercentage };
      this.negociationWeightIdToEdit = null;
    },

    openEditNegociationWeightDialog({ id, name, cpfOrCnpj }, isCnpj = false, weightNegociationId) {
      this.negociationFormWeightDialogOpen = true;
      const isPercentage = this.isPercentage;
      this.negociationToWeightCreation = { id, name, cpfOrCnpj, isCnpj, isPercentage };
      this.negociationWeightIdToEdit = weightNegociationId;
    },

    handleSuccessDelete(success) {
      if (success) {
        this.setPageNumberCNPJ(1);
        this.setPageNumberCity(1);
        this.fetchAllNegotiations();
        this.errors = ['Tarifa deletada com sucesso!'];
        this.errorsType = 'success';
      }
    },

    openDialogTrashCNPJ(item, index) {
      this.dialogTrashCNPJ = true;
      this.trashItemCNPJ = {
        ...item,
        index
      };
    }
  }
};
</script>

<style lang="scss"></style>
